import type { Dispatch, SetStateAction } from "react";
import { Stack } from "@mui/material";
import type { ControllerRenderProps } from "react-hook-form";

import { EntityTagFieldV2 } from "src/components/TagManagement/EntityTagFieldV2";
import { JsonTagSelector } from "src/components/TagManagement/JsonTagSelector";
import type { ComponentAppearance } from "src/components/appearance";
import type { IngredientFormType } from "../../../IngredientForm.types";

interface IngredientTagFieldProps {
    ingredient: IngredientFormType;
    setIngredient: Dispatch<SetStateAction<IngredientFormType>>;
    field: ControllerRenderProps<any, "tags">;
    appearance?: ComponentAppearance;
}

export const IngredientTagField = (props: IngredientTagFieldProps) => {
    const { ingredient, setIngredient, field, appearance = "legacy" } = props;

    const handleTagsChange = (updatedTags: Record<string, string[]>) => {
        setIngredient((current) => {
            return {
                ...current,
                tags: updatedTags,
            };
        });
        field.onChange(updatedTags);
    };

    if (appearance === "product-v2") {
        return <EntityTagFieldV2 context="ingredient" tags={ingredient.tags} onTagsChange={handleTagsChange} />;
    }

    return (
        <Stack gap={1}>
            <JsonTagSelector
                entity={{
                    id: ingredient.id || "new",
                    tags: ingredient.tags || {},
                }}
                entityClass="App\Entity\Ingredient"
                context="ingredient"
                onTagsChange={handleTagsChange}
                hideTitle
                appearance={appearance}
            />
        </Stack>
    );
};

export default IngredientTagField;
